import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { __t } from '../../../../../../base/utils/t';
import { workerAppActions } from '../../../../../redux/slices/workerAppSlice';
import { passwordRecoveryActions } from '../../../redux/slices/passwordRecoverySlice';
import { Confirmation as ConfirmationComponent } from '../../../../../components/Confirmation';

export const Confirmation = () => {
    const dispatch = useAppDispatch();
    const {
        fields: { phone, smsCode },
        errors,
    } = useAppSelector((state) => state.workerAppPasswordRecovery);

    const smsCodeVerificationCodeChangeHandler = (value: unknown) => {
        dispatch(passwordRecoveryActions.setField({ id: 'smsCode', value }));
    };

    const submitSmsResendCode = (recaptchaToken: string | null, callback: () => void) => {
        dispatch(workerAppActions.sendConfirmationCode(phone, recaptchaToken, callback));
    };

    const submitCode = () => dispatch(passwordRecoveryActions.submitRecoverPassword());

    const submitChangeConfirmationValue = (newValue: string, recaptchaToken: string | null, callback: () => void) => {
        dispatch(passwordRecoveryActions.submitChangeConfirmationValue(newValue, recaptchaToken, callback));
    };

    return (
        <div className='password-recovery password-recovery__confirmation'>
            <ConfirmationComponent
                confirmationMethod='phone'
                codeValue={smsCode || ''}
                text={
                    <>
                        {__t('Чтобы подтвердить действие, введите код, отправленный вам в Viber/SMS на номер')}
                        &nbsp;
                        <strong>{phone}</strong>
                    </>
                }
                codeErrors={errors?.smsCode}
                changeConfirmationValueErrors={errors?.phone}
                updateModalText={__t('Телефон, на которий вы регистрировались')}
                verificationCodeChangeHandler={smsCodeVerificationCodeChangeHandler}
                submitResendCode={submitSmsResendCode}
                submitCode={submitCode}
                submitChangeConfirmationValue={submitChangeConfirmationValue}
            />
        </div>
    );
};
